// extracted by mini-css-extract-plugin
export default {"tabsContainer":"TabSelector_tabsContainer__y4LCj","tabHeading":"TabSelector_tabHeading__fspGu","tab":"TabSelector_tab__ZKXqv","tab--selected":"TabSelector_tab--selected__aCiGO"};